import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SharedTable from 'shared/ui/Table';
import { selectServices, selectIsFetching, selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import { setOrderByServicesAssets } from 'store/Contextualization/AssetDetail/actions';
import { selectOrderBy } from 'store/Filters/selectors';
import hostServicesSchema from './schema';
import selectAssetServicesFields from 'store/Preferences/assetServices/selectors';
import NoSearchResults from 'Common/Components/NoSearchResults';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_TAGS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const ServicesTable = () => {
  const dispatch = useDispatch();
  const services = useSelector(selectServices);
  const isFetching = useSelector((state) => selectIsFetching('services', state));
  const fields = useSelector(selectAssetServicesFields);
  const isTagsAllowedByLicense = useSelector((state) => selectAllowedByRole(state, FEATURE_TAGS, PERMISSION_TYPES.READ));
  const servicesSelected = useSelector((state) => selectSelected('services', state));
  const orderBy = useSelector((state) => selectOrderBy('servicesAssets', state));
  const defaultSorted = orderBy.map(({ field, direction }) => ({ id: field, desc: direction === 'desc' }));
  const hasMounted = useRef(false);

  const isRowSelected = (rowInfo) => !!servicesSelected.find((vuln) => vuln._id === rowInfo.original._id);

  const getThProps = (column, fields) => {
    const defaultMin = fields[column.id] ? fields[column.id].defaultWidth : 0;
    const maxWidth = fields[column.id] ? fields[column.id].maxWidth : 0;
    const response = { minWidth: defaultMin, maxWidth };
    return {
      style: defaultMin ? response : {}
    };
  };

  const fetchData = (sorted) => {
    // The parent HostServices screen already fetches services on mount; skip the
    // table's own initial onFetchData call to avoid firing the request twice.
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }
    if (!isFetching) dispatch(setOrderByServicesAssets(sorted));
  };

  return (
    <SharedTable
      schema={ hostServicesSchema }
      context={ { fields, isFetching, isTagsAllowedByLicense } }
      data={ services }
      isLoading={ isFetching }
      defaultSorted={ defaultSorted }
      onFetch={ fetchData }
      isRowSelected={ isRowSelected }
      getHeaderProps={ (column) => getThProps(column, fields) }
      noDataText={ !isFetching && <NoSearchResults /> }
    />
  );
};
export default ServicesTable;
